export { default } from './Slider';
export * from './sliderClasses';
export { default as sliderClasses } from './sliderClasses';
export * from './SliderProps';
